import { Base } from "ui/Scripts/source/framework/base";
import { ListItems } from "ui/Scripts/source/framework/listItems";
import { IRecordEditItemLogListItem, RecordEditItemLogListItem } from "./recordEditItemLogListItem";

export interface IRecordEditItemLogListItems extends ListItems<IRecordEditItemLogListItem> { }

export class RecordEditItemLogListItems extends ListItems<IRecordEditItemLogListItem> implements IRecordEditItemLogListItems {
    constructor();
    constructor(obj: IRecordEditItemLogListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, RecordEditItemLogListItem);
    }
}